// Vendors
import styled from 'styled-components';
import { getStyles } from '@kubit/web-ui-components';
const TitleMainWrapperStyled = styled.section `
  ${({ styles }) => getStyles(styles?.container)}
`;
TitleMainWrapperStyled.displayName = 'TitleMainWrapperStyled';
const LeftWrapper = styled.div `
  ${({ styles }) => getStyles(styles?.leftContainer)}
`;
LeftWrapper.displayName = 'LeftWrapper';
const RightWrapper = styled.div `
  ${({ styles }) => getStyles(styles?.rightContainer)}
`;
RightWrapper.displayName = 'RightWrapper';
const BuilderStyled = styled.div `
  ${({ styles }) => getStyles(styles?.builder)}
`;
BuilderStyled.displayName = 'BuilderStyled';
export { BuilderStyled, LeftWrapper, RightWrapper, TitleMainWrapperStyled };
//# sourceMappingURL=title.component.styled.js.map